import webStorage from 'store2';

export const userStorage = webStorage.namespace('user');
